import React, { useEffect } from 'react';
import { ScrollView, View } from 'react-native';

import { isEmpty as _isEmpty, isNil as _isNil, isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import { PaymentMethodsTrackingManager } from '../../../Utils/TrackingManagers';
import AddNewCardButton from '../../Components/PaymentMethodCard/AddNewCardButton';
import PaymentMethodsList from '../../Components/PaymentMethodsList';
import PreferredPaymentMethod from '../../Components/PreferredPaymentMethod';

import styles from './PaymentMethods.Styles';

function PaymentMethods({
  isLoading,

  cards,
  preferredCard,
  onPressMakePreferred,
  withTray,
  renderEmptyCardsContent,
  onAddNewPaymentMethodPress,
  makePreferredBtnStyle,
  handleCardPress,
}) {
  useEffect(() => {
    PaymentMethodsTrackingManager.trackView();
  }, []);
  const isCardsListEmpty = _isEmpty(cards) && !isLoading;
  const noPreferredPayment = _isNil(preferredCard) && !isLoading;
  const noCardExist = isCardsListEmpty && noPreferredPayment;
  return (
    <ScrollView
      pointerEvents={isLoading ? 'none' : 'auto'}
      showsVerticalScrollIndicator={false}
      contentContainerStyle={[
        withTray && styles.scrollViewContentContainerWithTray,
        styles.scrollViewContentContainer,
        { paddingHorizontal: '10%' }
      ]}
      testID={FrameworkTestKeys.PaymentMethodsView}
    >
      {/* <View style={styles.addCardSection}>
        <AddNewCardButton isLoading={isLoading} onPress={onAddNewPaymentMethodPress} />
      </View> */}
      {noCardExist && _isFunction(renderEmptyCardsContent) && renderEmptyCardsContent()}
      {!noPreferredPayment && (
        <PreferredPaymentMethod
          isLoading={isLoading}
          onCardPress={() => handleCardPress(preferredCard.id)}
          preferredCard={preferredCard}
        />
      )}
      {!isCardsListEmpty && (
        <PaymentMethodsList
          isLoading={isLoading}
          onCardPress={cardId => handleCardPress(cardId)}
          cards={cards}
          onPressMakePreferred={onPressMakePreferred}
          makePreferredBtnStyle={makePreferredBtnStyle}
        />
      )}
    </ScrollView>
  );
}

PaymentMethods.propTypes = {
  isLoading: PropTypes.bool,
  cards: PropTypes.array,
  preferredCard: PropTypes.object,
  onPressMakePreferred: PropTypes.func,
  onPressAddNewPaymentMethod: PropTypes.func,
  withTray: PropTypes.bool,
  renderEmptyCardsContent: PropTypes.func,
  onAddNewPaymentMethodPress: PropTypes.func,
  makePreferredBtnStyle: PropTypes.shape({
    parent: PropTypes.object,
    container: PropTypes.object,
    text: PropTypes.object,
  }),
  handleCardPress: PropTypes.func,
};

export default PaymentMethods;
